// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3hak8","main":"App_main__3Q4l6","body":"App_body__2rRFM","heading":"App_heading__29Av-"};